import { styled } from '@mui/material/styles';
import { ActionButton } from '@/components/buttons';

export const Container = styled('div')({});

export const ActionButtonStyled = styled(ActionButton)({
  width: 'fit-content',
  marginBottom: '10px',
});
